import React, { type FC } from 'react'

import { Capability, CybusLogSource, type CybusServer, Translation } from '../../../../domain'

import Logs, { LogsAvailability } from '../../Logs'
import NodesTable from '../../Nodes'
import { Tab, Tabs } from '../../Tabs'

export const Content: FC<{ resource: CybusServer }> = ({ resource }) => {
    const { id } = resource

    return (
        <LogsAvailability type={CybusLogSource.SERVER} id={id}>
            {(available) => (
                <Tabs>
                    <Tab title={Translation.SERVER_LOGS} disabled={!available} requiredCapabilities={[Capability.LOGS_READ]}>
                        <Logs id={id} type={CybusLogSource.SERVER} reloadOn={resource} />
                    </Tab>
                    <Tab title={Translation.NODE} requiredCapabilities={[Capability.NODES_READ]}>
                        <NodesTable serverId={id} />
                    </Tab>
                </Tabs>
            )}
        </LogsAvailability>
    )
}
